<template>
  <div>
   
    <div>
      <v-card
        class="mx-auto"
        max-width="1000"
        min-width="300"
      >
        <v-toolbar  class="pencil"  :color="ToolColor" dark @click="Loadin();Hide = !Hide">
          <v-toolbar-title>{{ Headline }}</v-toolbar-title>

          <v-toolbar-side-icon color="white darken-1">
            <v-icon v-if="Hide == false" color="orange ligthen-1"
              >arrow_downward</v-icon
            >
            <v-icon v-else color="orange ligthen-1">arrow_upward</v-icon>
          </v-toolbar-side-icon>

          <v-spacer></v-spacer>
        </v-toolbar>
        
  <v-expand-transition>
        <div  v-if="Hide">
          
           <div >
      <v-flex justify="center">
       <NewCase    
                      :id="person.id"
                      :schoolId="person.schoolId"
                      :teachernameandId="teachernameandId"
                      :membernameandId="membernameandId"  v-model="dialogcreate" />
                      <div v-if="typ=='teacher'">
  <v-btn dark large class="b" color="green ligthen-1" @click="dialogcreate = true">
            Skapa ärende
          </v-btn>    
            <v-btn dark large class="b" color="yellow darken-1" @click="dialogviolate = true">
            Kränkningsanmälan
          </v-btn> 
         <Violations
          :schoolId="person.schoolId"
          :id="person.id"
          :typ="typ"
          v-model="dialogviolate"
        />

           <!-- <Subscribe v-if=" casesFetched"
                      :myCases="Content"
                      :id="person.id"
                      :schoolId="person.schoolId"
                      v-model="dialogSub" /> -->
                      </div>
      </v-flex>
    </div>
          <div v-if="Content.length!=0">
   
           <DataTable :myCases="Content" :typ="typ" :role="person.role" :id="person.id" :schoolId="person.schoolId" />

          </div> 
          <div v-else  class="bellowPen" :class="ToolColor+ ' lighten-2 text-center'">  
    <span class="tt" color="white">Det finns inga ärenden än för de klasser du undervisar.</span>
    </div>
                    
        </div>
              
  </v-expand-transition>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import NewCase from "./NewCase";
import Subscribe from './Subscribe';
import DataTable from './DataTable';
import Violations from '../violationreport/Violations';

export default {
  components: {
    NewCase,Subscribe,DataTable,
    Violations
  },
  props:
  {
    person: Object,
    // Content: Array,
    Headline: String,
    ToolColor: String,
    typ: String,
    init: String,
  },
  computed: {
    ...mapGetters("teachers", [ 'casesFetched',"teachernameandId"]),
    ...mapGetters("ehtmembers", ["membernameandId"]),
    ...mapGetters("classesAP", ["classes"]),
    // ...mapGetters("cases", ["classes"]),

    ...mapGetters({ cases: 'teachers/cases'}),
    ...mapGetters({ AllCases: 'cases/cases'}),
    ...mapGetters({ AllCasesFetched: 'cases/casesFetched'}),

Content(){ //Använder de separata filterna och ger värden till variabeln Content
//console.log(this.cases)
  if (this.typ=="teacher") {
  return this.cases
  }
  else if (this.Headline=="Mina ärenden") {
    return this.AllCases.filter(C => C.steps[C.steps.length-1].ownerId == this.person.id).filter(C => C.steps[C.steps.length-1].step != 'Avslut & Arkivering')
  }
    else if (this.Headline=="Alla ärenden") {
    return this.AllCases.filter(C => C.steps[C.steps.length-1].step != 'Avslut & Arkivering')
  }
    else if (this.Headline=="Arkiverade ärenden") {
    return this.AllCases.filter(C => C.steps[C.steps.length-1].step == 'Avslut & Arkivering')
  }
}

  },
  // created() {
  //   if (this.init == "true") {
  //     this.initteachers(this.person.schoolId);
  //     this.initEHT(this.person.schoolId);
  //   }
  // },
 
  watch: {
  // cases: function() {
  //   //console.log(cases)
  //   this.Content=this.cases

  // }
  },
  methods: {
    
    ...mapActions('teachers', ['initcases']),
    
    ...mapActions('cases', ['initcasesEHT']),
    Loadin()
    {
      //console.log(this.casesFetched)
       if(this.typ=="teacher") //Klar för lärare men inte eht
      {
       if (this.casesFetched==false) {
        
         
          
      if(this.classes.length!=0)   
      {
      this.initcases(this.classes)

//console.log("Fetched"); 
      }

      }
      }
      else{
     if (this.AllCasesFetched==false) 
      {
          //console.log("Fetched"); 
      this.initcasesEHT(this.person.schoolId)
      }
      }
  

    },
   
  },
  data() {
    return {
      removeItem: {name:"temp",id:"temp"},
      dialogDelete:false,
      Hide: false,
      // Content: [],
      dialogcreate: false,
      dialogSub: false,
      dialogviolate:false,
    };
  },
};
</script>

<style scoped>
td,
th {
  border: 1px solid #ddd;
  padding: 8px;
}
tr:hover {
  background-color: #ddd;
}
#test:nth-child(even) {
  background-color: #f2f2f2;
}

th:hover {
  background-color: #f38e4b;
}

th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #f18a45;
  color: white;
}

h1 {
  font-size: 2em;
  color: purple;
}
#customers {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#customers td,
#customers th {
  border: 1px solid #ddd;
  padding: 8px;
}

#customers tr:nth-child(even) {
  background-color: #f2f2f2;
}

#customers tr:hover {
  background-color: #ddd;
}

#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #4caf50;
  color: white;
}
.b{
  font-size: 1.3em;
}
</style>